<script>
import amountMask from '@lib/utils/amount-mask'

export default {
  name: 'ProductFormPriceStep',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    salesTax: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      required: true,
      validator: v => !v || /supplier|provider/.test(v),
    },
  },
  data() {
    return {
      currencies: {
        AUD: 'Australian Dollars - AUD',
        USD: 'Dollars USA - USD',
        EUR: 'Euros - EUR',
      },
    }
  },
  computed: {
    rules() {
      const { form, isTypeProvider } = this
      return {
        'sales_tax_applicable': [
          {
            required: true,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'pricing.price_before_tax': [
          {
            required: isTypeProvider && !form.pricing.rrp_before_tax,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
        'pricing.rrp_before_tax': [
          {
            required: isTypeProvider && !form.pricing.price_before_tax,
            message: 'This field is required',
            trigger: 'blur',
          },
        ],
      }
    },
    isTypeProvider() {
      return this.type === 'provider'
    },
  },
  methods: {
    amountMask,
    changeValue(field, value) {
      this.$emit('change', { field, value })
    },
    calcAfterTax(field, target) {
      const priceBefore = Number(this.form.pricing[field])
      const salesTaxApplicable = this.form.sales_tax_applicable
      const salesTax = this.salesTax / 100
      let value

      if (priceBefore === null) {
        value = null
      } else if (priceBefore && salesTaxApplicable === 'Applicable') {
        value = priceBefore * (1 + salesTax)
      } else if (priceBefore && (salesTaxApplicable === 'Not Applicable' || salesTaxApplicable === 'Free of Sales Tax')) {
        value = priceBefore
      }

      this.$emit('change', { field: `pricing.${target}`, value: value && Number(value).toFixed(2) })
      return value && Number(value).toFixed(2)
    },
  },
}
</script>

<template>
  <div>
    <el-form
      class="modal-form"
      label-position="top"
      :model="form"
      :rules="rules"
    >
      <div class="united-field">
        <el-form-item
          label="Currency"
        >
          <el-input
            :value="currencies[form.currency]"
            disabled
          />
        </el-form-item>
      </div>

      <div class="united-field">
        <el-form-item
          label="Sales Tax"
          prop="sales_tax_applicable"
        >
          <el-select
            :value="form.sales_tax_applicable"
            @input="changeValue('sales_tax_applicable', $event)"
          >
            <el-option
              value="Free of Sales Tax"
              label="Free of Sales Tax"
            />
            <el-option
              value="Applicable"
              label="Applicable"
            />
            <el-option
              value="Not Applicable"
              label="Not Applicable"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="Before Tax Cost Price"
        >
          <el-input
            placeholder="Enter amount"
            :value="form.pricing.cost"
            @input="changeValue('pricing.cost', amountMask($event))"
          >
            <template
              #append
            >
              {{ form.currency }}
            </template>
          </el-input>
        </el-form-item>
      </div>

      <div class="united-field">
        <el-form-item
          label="Before Tax Price"
          prop="pricing.price_before_tax"
        >
          <el-input
            placeholder="Enter amount"
            :value="form.pricing.price_before_tax"
            @input="changeValue('pricing.price_before_tax', amountMask($event))"
          >
            <template
              #append
            >
              {{ form.currency }}
            </template>
          </el-input>
        </el-form-item>

        <el-form-item
          label="After Tax Price"
        >
          <el-input
            :placeholder="!isTypeProvider && 'Enter amount'"
            :value="isTypeProvider ? calcAfterTax('price_before_tax', 'price_after_tax') : form.pricing.price_after_tax"
            :disabled="isTypeProvider"
            @input="changeValue('pricing.price_after_tax', amountMask($event))"
          >
            <template
              #append
            >
              {{ form.currency }}
            </template>
          </el-input>
        </el-form-item>
      </div>

      <div class="united-field">
        <el-form-item
          label="Before Tax RRP"
          prop="pricing.rrp_before_tax"
        >
          <el-input
            placeholder="Enter amount"
            :value="form.pricing.rrp_before_tax"
            @input="changeValue('pricing.rrp_before_tax', amountMask($event))"
          >
            <template
              #append
            >
              {{ form.currency }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          label="After Tax RRP"
        >
          <el-input
            :placeholder="!isTypeProvider && 'Enter amount'"
            :value="isTypeProvider ? calcAfterTax('rrp_before_tax', 'rrp_after_tax') : form.pricing.rrp_after_tax"
            :disabled="isTypeProvider"
            @input="changeValue('pricing.rrp_after_tax', amountMask($event))"
          >
            <template
              #append
            >
              {{ form.currency }}
            </template>
          </el-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
